// Copyright © 2021 Move Closer
/**
 * @returns - Object representing the module's size (dimensions).
 *
 * @param [colSpan=6]
 * @param [rowSpan=1]
 * @param [isResizable=true]
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const getModuleSize = (colSpan, rowSpan, isResizable) => {
    if (typeof colSpan !== 'number') {
        colSpan = 6;
    }
    if (typeof rowSpan !== 'number') {
        rowSpan = 1;
    }
    if (typeof isResizable !== 'boolean') {
        isResizable = true;
    }
    return {
        colSpan,
        isResizable,
        rowSpan
    };
};
/**
 * Generated the base fields of the `Module` interface, including:
 *  - id
 *  - size
 *  - version
 *  - title
 *
 *  @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const getModuleBase = () => ({
    id: '',
    isVisible: true,
    isLazyLoaded: true,
    isMobileVisible: true,
    isDesktopVisible: true,
    size: getModuleSize(),
    version: '',
    title: ''
});
